import {
  Inject,
  Injectable,
  Optional,
  Renderer2,
  SkipSelf,
  InjectionToken,
  DOCUMENT,
} from "@angular/core";

import { WINDOW } from "shared/helper-services/window-token.module";

import { Subject } from "rxjs";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxDocumentMouseEnterService {
  private documentMouseEnterSubject = new Subject<Event>();
  public $documentMouseEnter = this.documentMouseEnterSubject.asObservable();

  constructor(
    @Inject(DOCUMENT) private document: any,
    @Inject(WINDOW) private window: any,
  ) {
    let mouseEnterRef = this.onMouseEnter.bind(this);

    document.addEventListener("mouseenter", mouseEnterRef, { passive: true });
  }

  protected onMouseEnter($event) {
    this.documentMouseEnterSubject.next($event);
  }
}
